import {
	AppBar,
	Avatar,
	Button,
	Card,
	CssBaseline,
	Divider,
	Drawer,
	IconButton,
	Link,
	List,
	Toolbar,
	Tooltip,
	Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import Cookies from "universal-cookie";
import MainListItems from "./commons/MainListItems";
import UserMenu from "./commons/UserMenu";
import logo from "./images/lasa_logo.png";
import consts from "./main/consts";
import {
	addMessage,
	atualizarTokeLojaNotification,
	removeMessage,
} from "./state/app/appActions";
import { doLogout } from "./state/auth/authActions";
import { getAppUser } from "./views/components/helpers";
import TutorialModal from "./views/components/TutorialModal";
import "./App.css";
import * as M from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ListIcon from "@material-ui/icons/List";
import Draggable from "react-draggable";
import Iframe from "react-iframe";
import laisIcon from "./images/lais-icon.svg";

import { StorageUser } from "./main/StorageUser";
import AlertaGlobalPreVenda from "./views/components/GlobalAlerts/AlertaGlobalPreVenda";

const drawerWidth = 240;

const styles = (theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		height: "100vh",
		paddingTop: 64,
		boxSizing: "border-box",
		"& .alerta-global-pre-venda ~ .MuiDrawer-root $drawerPaperClose": {
			paddingTop: 116,
		},
	},
	toolbar: {
		paddingRight: 8, // keep right padding when drawer closed
		justifyContent: "space-between",
		height: "4rem",
	},
	verticalDivider: {
		backgroundColor: "rgba(255,255,255,0.4)",
		margin: "14px 26px",
	},
	toolbarContainer: {
		display: "flex",
		flexDirection: "row",
	},
	toolbarContainerRight: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
		justifyContent: "flex-end",
		alignItems: "center",
	},
	toolbarIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: "0 8px",
		...theme.mixins.toolbar,
		// visibility: 'hidden'
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginLeft: -12,
		textDecoration: "none",
	},
	menuButtonHidden: {
		display: "none",
	},
	drawerPaper: {
		position: "relative",
		whiteSpace: "nowrap",
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerPaperClose: {
		overflowX: "hidden",
		width: 72,
		paddingTop: 72,
	},
	listMenu: {
		padding: 0,
		height: "100%",
		display: "flex",
		minHeight: 480,
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
		[theme.breakpoints.down("xs")]: {
			paddingTop: 2,
		},
	},
	justifyContent: "space-between",
	appBarSpacer: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		paddingLeft: 96,
		overflow: "auto",
	},
	chartContainer: {
		marginLeft: -22,
	},
	tableContainer: {
		height: 320,
	},
	h5: {
		marginBottom: theme.spacing(2),
	},
	link: {
		color: "inherit",
	},
	avatar: {
		borderRadius: 0,
		marginTop: 4,
		objectFit: "contain",
		width: 26,
		height: "auto",
	},
	avatarContainer: {
		width: theme.spacing(7),
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(9),
		},
		minWidth: 72,
		display: "flex",
		justifyContent: "center",
	},
	userInfoContainer: {
		marginRight: 10,
	},
	userInfo: {
		color: "#ffffff",
		fontWeight: 600,
	},
	footer: {
		height: 46,
		padding: theme.spacing(1),
		paddingLeft: 96,
		borderTop: "1px solid #CCC",
	},
	footerVersion: {
		margin: 6,
		textAlign: "right",
	},
	menuRight: {
		color: "white",
		fontSize: "1.35rem",
	},
	titleLais: {
		color: "#33333",
		fontSize: "1.35rem",
		fontWeight: 700,
	},
	subTitleLais: {
		color: "#33333",
		fontSize: "1.1rem",
		fontWeight: 300,
		marginLeft: 5,
	},
	loja: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		margin: theme.spacing(0, 1),
	},
	lais: {
		borderRadius: "0.5rem",
		zIndex: 1201,
		width: "23rem",
		height: "38rem",
		bottom: "3.2rem",
		right: "4.2rem",
		border: "2px solid rgb(51, 85, 171)",
	},
	avatarLais: {
		width: 68,
		height: 68,
	},
	laisBtn: {
		borderRadius: "50%",
	},
	laisContainerOpen: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		width: "23rem",
		height: 64,
		background:
			"transparent linear-gradient(223deg, #BC021D 0%, #3355AB 100%) 0% 0% no-repeat padding-box",
		cursor: "pointer",
		paddingLeft: 6,
	},
	laisContainerClose: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		width: "23rem",
		height: 43,
		backgroundColor: "#ffff",
		cursor: "pointer",
		borderRadius: 28,
	},
	laisContainerWrapper: {
		padding: 4,
		borderRadius: 32,
		background:
			"transparent linear-gradient(223deg, #BC021D 0%, #3355AB 100%) 0% 0% no-repeat padding-box",
	},
	boxTextLaisClose: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
	},
	boxTextLaisOpen: {
		width: "100%",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
	},
	notification: {
		color: "white",
		fontSize: "1rem",
		textTransform: "capitalize",
	},
	notificationCodigo: {
		color: "white",
		fontSize: "1.2rem",
		fontWeight: "bold",
		marginLeft: 5,
	},
});

class App extends Component {
	state = {
		drawerOpened: false,
		tutorialOpened: false,
		hideLais: true,
	};

	goToNewOrders = (numero, key) => {
		this.props.history.push(`${consts.CONTEXT}/new-orders/${numero}`, {
			data: { page: "new-orders" },
		});
		this.props.closeSnackbar(key);
	};

	action = (key, title, { codigoExterno, numero }) => (
		<Fragment>
			<Button onClick={() => (numero ? this.goToNewOrders(numero, key) : null)}>
				<Typography className={this.props.classes.notification}>
					{title}
				</Typography>
				<Typography className={this.props.classes.notificationCodigo}>
					{codigoExterno}
				</Typography>
			</Button>
			<Button onClick={() => this.props.closeSnackbar(key)}>
				<CloseIcon fontSize="small" style={{ color: "#ffff" }} />
			</Button>
		</Fragment>
	);

	handleDrawer = () => {
		const { drawerOpened } = this.state;
		this.setState({ drawerOpened: !drawerOpened });
	};

	handleOpenTutorial = () => {
		this.setState({ tutorialOpened: true });
	};

	handleCloseTutorial = () => {
		this.setState({ tutorialOpened: false });
	};

	logout = () => {
		this.props.doLogout().then(() => {
			console.log("logout microsoftonline");
			window.location = consts.LOGOUT_URL;
		});
	};

	goToRoute = (route) => {
		this.props.history.push(`/${route}`);
	};

	handleClickVariant = (message, variant) => () => {
		const { addMessage } = this.props;
		addMessage({ message, variant });
	};

	setTokenFound = (token) => {
		this.props.atualizarTokeLojaNotification(this.props.auth.loja, token);
	};

	componentDidMount() {
		const cookies = new Cookies();
		if (!cookies.get("tutorial-seen") && consts.SHOW_TUTORIAL) {
			this.setState({ tutorialOpened: true });
			cookies.set("tutorial-seen", true, { path: "/" });
		}
	}

	// TODO: Remover esse método UNSAFE
	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.messageDataList !== nextProps.messageDataList) {
			nextProps.messageDataList.forEach((messageData) => {
				const { message, ...params } = messageData;
				this.props.removeMessage(messageData);
				this.props.enqueueSnackbar(message, { ...params });
			});
		}
	}

	render() {
		const appuser = getAppUser();

		const { drawerOpened } = this.state;
		const { classes } = this.props;

		const app_version = consts.APP_VERSION;

		return (
			<div className={classes.root}>
				<CssBaseline />
				<AppBar
					position="absolute"
					className={classNames(
						classes.appBar,
						drawerOpened && classes.appBarShift,
					)}
				>
					<Toolbar disableGutters={!drawerOpened} className={classes.toolbar}>
						<div className={classes.toolbarContainer}>
							<div className={classes.avatarContainer}>
								<Link href={`${consts.CONTEXT}/all-orders`}>
									<img src={logo} className={classes.avatar} />
								</Link>
							</div>
						</div>

						<div className={classes.toolbarContainerRight}>
							{this.props.auth && this.props.auth.loja && (
								<>
									<div className={classes.loja}>
										<Typography className={classes.menuRight}>
											Loja {this.props.auth.loja}
										</Typography>
									</div>
								</>
							)}
							<Divider
								orientation="vertical"
								flexItem
								className={classes.verticalDivider}
							/>
							<UserMenu
								logout={this.logout}
								appuser={appuser}
								openTutorial={this.handleOpenTutorial}
							/>
						</div>
					</Toolbar>
				</AppBar>

				<AlertaGlobalPreVenda />
        
				<Drawer
					variant="permanent"
					classes={{
						paper: classes.drawerPaperClose,
					}}
				>
					<List className={classes.listMenu}>
						<MainListItems drawerOpened={drawerOpened} />
					</List>
					<Divider />
				</Drawer>

				<TutorialModal
					open={this.state.tutorialOpened}
					handleClose={this.handleCloseTutorial}
				/>

				<main className={classes.content}>{this.props.children}</main>

				<div className={classes.footer}>
					<div className={classes.footerVersion}>Versão: {app_version}</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	messageDataList: state.app.messageDataList,
	auth: state.auth,
});
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			addMessage,
			removeMessage,
			doLogout,
			atualizarTokeLojaNotification,
		},
		dispatch,
	);
export default compose(
	withRouter,
	withSnackbar,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
)(App);
